import { useEffect, useState } from "react";

// Branded splash screen shown once per browser session on first app load.
// Mirrors the iOS apple-touch-startup-image (`/splash.png`) so installed PWA
// and web first-load feel native and on-brand.
const SESSION_KEY = "rn3_splash_shown_v1";

export default function AppSplash() {
  const [visible, setVisible] = useState(() => {
    try { return !sessionStorage.getItem(SESSION_KEY); } catch { return true; }
  });
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (!visible) return;
    try { sessionStorage.setItem(SESSION_KEY, "1"); } catch { /* noop */ }
    // Hold for 1.6s, then fade out over 500ms
    const t1 = setTimeout(() => setFadeOut(true), 1600);
    const t2 = setTimeout(() => setVisible(false), 2100);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      data-testid="app-splash"
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backgroundColor: "#3F0A0E",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: fadeOut ? 0 : 1,
        transition: "opacity 500ms ease-out",
        pointerEvents: fadeOut ? "none" : "auto",
      }}
    >
      <img
        src="/splash-1024.png"
        alt="Roman Numerals III"
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          width: "auto",
          height: "100%",
          objectFit: "contain",
          objectPosition: "center",
          display: "block",
        }}
        // Hide the broken-image icon if the asset fails — the deep-red bg still reads as brand
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
    </div>
  );
}
